
<!--
* A language element with flag and text
*
* @param {boolean} isActive - Whether the language item is active
* @param {Object} language - Language object with the following keys.
* @param {string} language.isoCode - Country's ISO 3166-1-alpha-2 code
                                     @see https://www.iso.org/obp/ui/#search/code/.
* @param {string} language.title - String to show beside flag.
* @param {number} language.id - Id of language item.
-->

<template>
  <!-- list item to display a language -->
  <li class="language__item"
      :language="language"
      v-on:click="onClick()"
      v-bind:class="{ 'language__item--state-active': isActive }">
    <!-- flag class -->
    <span class="language__flag flag-icon"
          v-bind:class="'flag-icon-' + language.countryIsoCode"></span>
    <!-- title -->
    <span class="language__title" v-text="language.title"></span>
    <!-- select button -->
    <img src="@/assets/theme/images/dark-select-arrow.png" class="language__select">
  </li>
</template>

<script>
  export default {
    props: [ 'language', 'isActive' ],
    methods: {
      onClick () {
        this.$emit('selected', this.language)
      }
    }

  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  // Library used for svg country flags
  // @see http://flag-icon-css.lip.is
  @import "flag-icon-css/css/flag-icon.css";

  $language-flag-width: 90px;
  $language-flag-height: 60px;
  $language-select-width: 10px;
  $language-item-background: $quaternary-brand-color;
  $language-item-active-background: darken($language-item-background, 10%);

  .language__item {
    font-family: $base-font-stack;
    font-weight: $semibold-font-weight;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: $dims-padding-default $dims-horizontal-gutter;
    background-color: $language-item-background;

    &:hover {
      background-color: $language-item-active-background;
    }
  }

  .language__item--state-active {
    background-color: $language-item-active-background;
  }

  .language__flag {
    width: $language-flag-width;
    height: $language-flag-height;
  }

  .language__title {
    flex: 1;
    padding: 0 $dims-padding-default;
  }

  .language__select {
    width: $language-select-width;
    height: auto;
  }

</style>
